export const DeviceTypes = {
  AUDIO: "audio",
  VIDEO: "video",
} as const;

export type DeviceType = (typeof DeviceTypes)[keyof typeof DeviceTypes];

export default DeviceTypes;
